export enum Grading {
  // empty
  EMPTY = '',
  UNGRADEABLE = 'ungradeable',
  ERROR = 'error',

  // fundus
  GOOD = 'good',
  USABLE = 'usable',
  REJECT = 'reject',
}

export enum QualityPrecheckEnum {
  Usable = 'usable',
  Reject = 'reject',
  Retake = 'retake',
}
